module.exports = __webpack_public_path__ + "img/acc_carousel_04.5a8ceee4.jpg";